import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, UntypedFormControl, Validators } from '@angular/forms';
import { AUTH_SERVICE, AuthService } from '../../services/auth.service';
import TYPES from '../../constants/types';
import { InputComponent } from "../../components/input/input.component";

import { ButtonComponent } from '../../components/button/button.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from "@angular/material/input";
import { Router } from '@angular/router';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';

@Component({
  selector: 'app-register',
  imports: [
    ReactiveFormsModule,
    ButtonComponent,
    InputComponent,
    TranslatePipe,
    MatDatepickerModule,
    MatInputModule,
    MatSnackBarModule
],
  templateUrl: './reset-password.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent {
  
  resetForm: FormGroup;
  BUTTON_TYPES: any;
  INFO_SCREEN: any;
  passwordControl: UntypedFormControl;
  passwordVerificationControl: UntypedFormControl;
  isResetButtonDisabled:boolean;

  private authService: AuthService = inject(AUTH_SERVICE);
  private translate: TranslateService = inject(TranslateService);
  private snackBar: MatSnackBar = inject(MatSnackBar);

  constructor(
    private formBuilder: FormBuilder,
    private router: Router
  ) {
    this.passwordControl = new UntypedFormControl('', [Validators.required, Validators.minLength(6)]);
    this.passwordVerificationControl = new UntypedFormControl('', [Validators.required]);
    
    this.resetForm = this.formBuilder.group({
      password: this.passwordControl,
      passwordVerification: this.passwordVerificationControl,
    });

    this.passwordVerificationControl.addValidators(()=> {
      return this.passwordControl.value === this.passwordVerificationControl.value ? null : { passwordMismatch: true };
    });

    this.isResetButtonDisabled = this.resetForm.invalid;
    this.resetForm.statusChanges.subscribe(
      (event => {
        this.isResetButtonDisabled = this.resetForm.invalid;
      })
    );

    this.BUTTON_TYPES = TYPES.UI.BUTTON;
    this.INFO_SCREEN = TYPES.UI.INFO_SCREEN;

  }

  async resetPassword() {
    console.log('Reseting password...');
    if(!this.isFormInvalid()){ 
      const error = await this.authService.updatePassword(
        this.resetForm.value.password
      );

      if(error === null){
        this.router.navigate([
          '/info', 
          this.INFO_SCREEN.SUCCESS, 
          'info.password_reseted', 
          'info.continue', 
          'info.welcome_back',
          'buttons.OK'
        ], { replaceUrl: true, queryParams: { email: this.resetForm.value.email } });
      }else{
        console.log(error);
        if(error.code === 'same_password'){
          const message = this.translate.instant('errors.same_password');
          const action = this.translate.instant('buttons.dismiss');
          this.snackBar.open(message, action);
        }
      }

    }else{
      this.resetForm.markAllAsTouched();
      this.resetForm.updateValueAndValidity();
    }
  }

  cancel()  {
    history.back();
  }

  isFormInvalid(): boolean{
    return this.resetForm.invalid
  }

}
